import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = { class: "p-4 pb-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-4 text-left border-b-2 border-green-show mb-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, "お気に入り")
], -1)
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_SVoucherCard = _resolveComponent("SVoucherCard")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_SBottomBar = _resolveComponent("SBottomBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_van_list, {
        loading: _ctx.isLoading,
        "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
        finished: _ctx.vouchers.isFinal,
        "finished-text": "",
        "loading-text": "loading",
        class: "space-y-4",
        onLoad: _ctx.loadMoreVouchers
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "finished", {}, () => [
            (!_ctx.vouchers.data.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_van_empty, { description: "表示できる特別優待はありません" })
                ]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vouchers.data, (voucher) => {
            return (_openBlock(), _createElementBlock("div", {
              key: voucher.voucherId
            }, [
              _createVNode(_component_SVoucherCard, { voucher: voucher }, null, 8, ["voucher"])
            ]))
          }), 128))
        ]),
        _: 3
      }, 8, ["loading", "finished", "onLoad"])
    ]),
    _createVNode(_component_SBottomBar)
  ]))
}